import React from 'react';
import styled from 'styled-components';

const Text = styled.span`
  white-space: pre;
`;

const TextList = ({ data }) => {
  if (!data || !data.length) {
    return '';
  }

  return data.map((item = {}) => {
    const {
      style,
      text,
    } = item;

    return (
      <Text style={style}>{text}</Text>
    );
  });
};

export default TextList;
